import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import getProductBestPrice from "./requests/getProductBestPrice";
import deleteProductRequest from "./requests/deleteProductRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const productEndpoints: RequestDefinitionData[] = [
    getProductBestPrice,
    deleteProductRequest,
];

export const productHeader = {
    title: 'Product',
    description: 'This is an object representing a Fishbowl product.',
    linkName: 'Product',
    link: 'https://www.fishbowlinventory.com/wiki/Product',
    endpoints: productEndpoints,
};

export const jsonObject: Json = {
    title: 'THE PRODUCT OBJECT',
    json: {}
};

export const productAttributes: Attribute[] = [];
